import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy/i18n';
import {OnePaneLayoutFullWidthSectionContent} from '@udemy/react-layout-components';

import {FreeResourcesCoursesSection} from './free-resources-courses-section/free-resources-courses-section.react-component';
import {FreeResourcesLecturesSection} from './free-resources-lectures-section/free-resources-lectures-section.react-component';
import styles from './free-resources-section.module.less';
export const FreeResourcesSection = () => {
    const {gettext} = useI18n();

    return (
        <OnePaneLayoutFullWidthSectionContent
            role="region"
            aria-labelledby="free-resources-heading"
            className={styles.container}
        >
            <div className={styles.header}>
                <h3 id="free-resources-heading" className="ud-heading-xxl">
                    {gettext('Looking for ideas to make AI work for you?')}
                </h3>

                <div className={classNames('ud-text-lg', styles['description'])}>
                    {gettext('Find out how others are using it to their advantage.')}
                </div>
            </div>

            <FreeResourcesCoursesSection />

            <FreeResourcesLecturesSection />
        </OnePaneLayoutFullWidthSectionContent>
    );
};
